import React from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable, runInAction } from 'mobx';
import { getp } from '../../helpers/getProp';
import { mutate } from '../../core/createApolloClient/createApolloClient.client';
import { View, Text } from '../../components_new/common';
import Button from '../../components_new/common/FormComponents/Button';
import { bs } from '../../helpers/styles-core';
import InputStyle from '../../components_new/common/FormComponents/InputStyle';
import sendVerificationSmsM from './sendVerificationSmsM';
import phoneVerificationCodeM from './phoneVerificationCodeM';
import Axios from 'axios';
import InputHeader from '../../components_new/common/FormComponents/InputHeader';

@inject('userStore')
@observer
export class ValidatePhoneInput extends React.Component {
  @observable error = '';
  @observable phoneNumber = '';
  @observable lastValidPhone = '';
  @observable needsValidation = false;
  @observable verificationCodeSent = false;
  @observable verificationCode = '';

  componentDidMount() {
    const { value, userStore } = this.props;
    if (value && value.match(/^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/)) {
      this.error = '';
    }
    if (userStore.phoneNumber) {
      this.phoneNumber = userStore.phoneNumber;
    }
    if (userStore.isPhoneVerified) {
      this.lastValidPhone = userStore.phoneNumber;
    } else if (
      userStore.phoneNumber &&
      userStore.phoneNumber.match(/^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/)
    ) {
      this.needsValidation = true;
    }
  }
  verify = () => {
    if (
      this.phoneNumber &&
      this.phoneNumber.match(/^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/)
    ) {
      this.error = '';
      if (this.phoneNumber !== this.lastValidPhone) {
        this.needsValidation = true;
      }
    } else {
      this.error = 'invalid phone number';
    }
  };

  blurPhone = () => {
    this.verify();
  };

  startVerify = async () => {
    this.verify();
    if (!this.error && this.phoneNumber && this.needsValidation) {
      const res = await mutate(sendVerificationSmsM, {
        phoneNumber: this.phoneNumber,
      });
      if (getp(res, 'data.AddPhoneNumber.status') == '200') {
        const res2 = await Axios.post('/send-verification-code', {
          dialCode: '1',
          phoneNumber: this.phoneNumber,
        });
        if (getp(res2, 'status') == 200) {
          runInAction(() => {
            this.verificationCodeSent = true;
          });
        }
      }
    }
  };

  @action
  endVerify = async () => {
    if (!this.verificationCode || this.verificationCode.length !== 4) {
      return;
    }
    const res = await mutate(phoneVerificationCodeM, {
      verificationCode: this.verificationCode,
    });
    if (getp(res, 'data.VerifyPhoneNumber.status') == '200') {
      runInAction(() => {
        this.lastValidPhone = this.phoneNumber;
        this.needsValidation = false;
        this.verificationCodeSent = false;
        this.props.userStore.updateValidPhone(this.phoneNumber);
      });
      if (this.props.onValidated) {
        this.props.onValidated();
      }
    } else {
      console.log('Error verifying', res);
      this.error =
        'Verification code did not match last sent code, please try again';
    }
  };

  phoneTextChanged = text => {
    this.phoneNumber = text;
    if (text && text.match(/^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/)) {
      this.verify();
    }
  };

  @action
  codeTextChanged = text => {
    this.verificationCode = text.target.value;
  };

  renderCode = () => {
    return (
      <View id="validation-code-container">
        <InputHeader
          label="Enter Verification Code"
          error={this.props.error || this.error}
        />
        <View className="relative">
          <InputStyle
            id="verification-code-input"
            value={this.verificationCode}
            onChange={this.codeTextChanged}
            placeholder="e.g. 1234"
          />
          <View className="absolute right-15 top-0 bottom-0 f-cc">
            <Button primary action onClick={this.endVerify}>
              Done
            </Button>
          </View>
        </View>
      </View>
    );
  };

  render() {
    if (this.verificationCodeSent) {
      return this.renderCode();
    }
    return (
      <View id="phone-number-container">
        <InputHeader
          label="U.S. Phone Number"
          error={this.props.error || this.error}
        />
        <View className="relative">
          <InputStyle
            id="phone-number-input"
            value={this.phoneNumber}
            onChange={e => this.phoneTextChanged(e.target.value)}
            placeholder="e.g. 555-555-5555"
            onBlur={this.blurPhone}
          />
          <View
            if={this.needsValidation}
            className="absolute right-15 top-0 bottom-0 f-cc"
          >
            <Button primary action onClick={this.startVerify}>
              Verify via SMS
            </Button>
          </View>
        </View>
        <View
          if={!this.needsValidation && this.lastValidPhone}
          className="absolute right-15 top-0 bottom-0 f-cc f-columns"
        >
          <Text primaryDark mr={1}>
            Verified
          </Text>
          <i className="fas fa-check-circle primaryDark" />
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Trust/ValidatePhoneInput.js